var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['font-sans'],attrs:{"role":_vm.accessibilityRole}},[_vm._l((_vm.rowsData),function(row,index){return [_c('div',{key:`${row.icon}-${index}`,ref:row.ref,refInFor:true,class:[
        // Always set `display` to `block` to avoid overrides
        'block',

        // This is the space between the hover box and the edge of the row
        'py-1',
        'px-2',
      ],attrs:{"data-cy":row.testId,"data-pw":row.testId,"data-pepin-id":row.analyticsId,"data-pepin-trigger":"click","role":"presentation"}},[_c(row.href ? 'a' : 'div',_vm._b({tag:"component",class:[
          'group',
          // Wanted to use the resets that's already on `<OzBaseButton>`, but can't use a `<button>` element here
          // because we use a `<button>` for the `rightIcon` and nested `<button>`s are invalid.
          'focus-visible:outline-none',

          row.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
          // TEXT COLORS
          row.rowStyle === _vm.RowStyle.Default && {
            'text-dark-text-100': _vm.darkMode === false,
            'text-light-text-100': _vm.darkMode === true,
            'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Disabled &&
            _vm.sizePreset === _vm.SizePreset.H44px && {
              'text-dark-text-300': _vm.darkMode === false,
              'text-light-text-300': _vm.darkMode === true,
              'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
            },
          row.rowStyle === _vm.RowStyle.Disabled &&
            _vm.sizePreset === _vm.SizePreset.H48px && {
              'text-dark-text-400': _vm.darkMode === false,
              'text-light-text-400': _vm.darkMode === true,
              'text-dark-text-400 dark:text-light-text-400': _vm.darkMode === 'auto',
            },
          row.rowStyle === _vm.RowStyle.Highlighted && {
            'font-semibold': true,
            'text-grape-500': _vm.darkMode === false,
            'text-canary-500': _vm.darkMode === true,
            'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Primary && 'text-padlet-pink-500',
          row.rowStyle === _vm.RowStyle.Secondary && {
            'text-dark-text-200': _vm.darkMode === false,
            'text-light-text-200': _vm.darkMode === true,
            'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
          },
          row.rowStyle === _vm.RowStyle.Danger && 'text-danger-100',
          // SHAPE
          'rounded-xl',
          // Combined with the space outside the hover box, the row has 16px of x-padding.
          'p-2',
          // 44px - 2*4px (padding outside hover box) - 2*8px (padding outside hover box) = 20px
          _vm.sizePreset === _vm.SizePreset.H44px && 'min-h-[20px]',
          // 48px - 2*4px (padding outside hover box) - 2*8px (padding outside hover box) = 24px
          _vm.sizePreset === _vm.SizePreset.H48px && 'min-h-[24px]',
          // 56px - 2*4px (padding outside hover box) - 2*8px (padding outside hover box) = 32px
          _vm.sizePreset === _vm.SizePreset.H56px && 'min-h-[32px]',

          // HIGHLIGHT STYLES
          !row.isDisabled && [
            'transition-colors',
            _vm.focusStyle === _vm.FocusStyle.Bubble100 && [
              {
                'hover-hover:hover:bg-light-ui-100 hover-hover:dark:hover:bg-dark-ui-100': _vm.darkMode === 'auto',
                'hover-hover:hover:bg-light-ui-100': _vm.darkMode === false,
                'hover-hover:hover:bg-dark-ui-100': _vm.darkMode === true,
              },
              {
                'active:bg-light-ui-100 dark:active:bg-dark-ui-100': _vm.darkMode === 'auto',
                'active:bg-light-ui-100': _vm.darkMode === false,
                'active:bg-dark-ui-100': _vm.darkMode === true,
              },
            ],
            _vm.focusStyle === _vm.FocusStyle.Bubble200 && [
              {
                'hover-hover:hover:bg-light-ui-200 hover-hover:dark:hover:bg-dark-ui-200': _vm.darkMode === 'auto',
                'hover-hover:hover:bg-light-ui-200': _vm.darkMode === false,
                'hover-hover:hover:bg-dark-ui-200': _vm.darkMode === true,
              },
              {
                'active:bg-light-ui-200 dark:active:bg-dark-ui-200': _vm.darkMode === 'auto',
                'active:bg-light-ui-200': _vm.darkMode === false,
                'active:bg-dark-ui-200': _vm.darkMode === true,
              },
            ],
            _vm.focusStyle === _vm.FocusStyle.Grey100 && [
              {
                'hover-hover:hover:bg-grey-100 hover-hover:dark:hover:bg-grey-700': _vm.darkMode === 'auto',
                'hover-hover:hover:bg-grey-100': _vm.darkMode === false,
                'hover-hover:dark:hover:bg-grey-700': _vm.darkMode === true,
              },
              {
                'active:bg-grey-100 dark:active:bg-grey-700': _vm.darkMode === 'auto',
                'active:bg-grey-100': _vm.darkMode === false,
                'active:bg-grey-700': _vm.darkMode === true,
              },
            ],
            _vm.focusStyle === _vm.FocusStyle.HighlightText && row.rowStyle === _vm.RowStyle.Default && _vm.textHighlightStyles,
          ],

          // FOCUS STYLES
          'focus-visible:ring-2',
          {
            'focus-visible:ring-grape-500 dark:focus-visible:ring-canary-500': _vm.darkMode === 'auto',
            'focus-visible:ring-grape-500': _vm.darkMode === false,
            'focus-visible:ring-canary-500': _vm.darkMode === true,
          },

          // INTERNAL LAYOUT
          'flex',
          'items-center',
          row.rowClasses,
        ],attrs:{"tabindex":0,"disabled":row.isDisabled,"aria-disabled":row.isDisabled,"href":row.href || null,"rel":row.href && 'noopener nofollow'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;$event.stopPropagation();$event.preventDefault();return _vm.selectRow($event, row)}]}},'component',_vm.getAccessibilityAttrs(row),false),[(_vm.xLeftIcon && row.icon)?_c('OzIcon',{class:[
            {
              'me-3': _vm.sizePreset === _vm.SizePreset.H44px,
              'me-4': _vm.sizePreset === _vm.SizePreset.H48px || _vm.sizePreset === _vm.SizePreset.H56px,
            },
            !row.isDisabled &&
              [_vm.FocusStyle.Bubble100, _vm.FocusStyle.Bubble200].includes(_vm.focusStyle) &&
              row.rowStyle === _vm.RowStyle.Default &&
              _vm.textHighlightStyles,
          ],attrs:{"name":row.icon,"size":_vm.iconSize}}):(_vm.$scopedSlots.startAdornment)?_vm._t("startAdornment",null,{"row":row,"iconSize":_vm.iconSize}):_vm._e(),_vm._v(" "),_c('div',{class:[
            row.textTruncated && 'truncate',
            'flex-1',
            row.textStyleClass || {
              'text-body-small': _vm.sizePreset === _vm.SizePreset.H44px,
              'text-body': _vm.sizePreset === _vm.SizePreset.H48px,
            },
            !_vm.xLeftIcon && 'ps-0.5',
          ],attrs:{"title":row.text}},[(row.htmlText)?_c('span',{domProps:{"innerHTML":_vm._s(row.htmlText)}}):_c('span',[_vm._v(_vm._s(row.text))])]),_vm._v(" "),(row.rightIcon)?_c('OzIcon',{class:[
            !row.isDisabled &&
              row.rightIconHighlighted && {
                'text-grape-500': _vm.darkMode === false,
                'text-canary-500': _vm.darkMode === true,
                'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
              },
            row.isDisabled &&
              row.rightIconHighlighted && {
                'text-modal-overlay-grape': _vm.darkMode === false,
                'text-modal-overlay-canary': _vm.darkMode === true,
                'text-modal-overlay-grape dark:text-modal-overlay-canary': _vm.darkMode === 'auto',
              },
            !row.isDisabled &&
              !row.rightIconHighlighted &&
              row.rowStyle === _vm.RowStyle.Default && {
                'text-dark-text-200 hover-hover:group-hover:text-dark-text-100': _vm.darkMode === false,
                'text-light-text-200 hover-hover:group-hover:text-light-text-100': _vm.darkMode === true,
                'text-dark-text-200 dark:text-light-text-200 hover-hover:group-hover:text-dark-text-100 hover-hover:dark:group-hover:text-light-text-100':
                  _vm.darkMode === 'auto',
              },
            !row.isDisabled &&
              _vm.focusStyle === _vm.FocusStyle.HighlightText &&
              row.rowStyle === _vm.RowStyle.Default &&
              _vm.textHighlightStyles,
          ],attrs:{"name":row.rightIcon,"size":row.rightIconSize || _vm.iconSize,"aria-label":row.rightIconAriaLabel}}):_vm._e()],2)],1),_vm._v(" "),(_vm.xLastRowDivider || index < _vm.rows.length - 1)?_c('OzDivider',{key:`${row.icon}-${index}-divider`,class:[
        !_vm.xLeftIcon && !_vm.$scopedSlots.startAdornment && 'mx-4',
        // 16px (left of icon) + 16px (icon) + 10px (right of icon) = ms-10.5
        (_vm.xLeftIcon || _vm.$scopedSlots.startAdornment) && _vm.sizePreset === _vm.SizePreset.H44px && 'ms-10.5 me-4',
        // 16px (left of icon) + 24px (icon) + 14px (right of icon) = ms-13.5
        (_vm.xLeftIcon || _vm.$scopedSlots.startAdornment) && _vm.sizePreset === _vm.SizePreset.H48px && 'ms-13.5 me-4',
        // 16px (left of icon) + 24px (icon) + 14px (right of icon) = ms-13.5
        (_vm.xLeftIcon || _vm.$scopedSlots.startAdornment) && _vm.sizePreset === _vm.SizePreset.H56px && 'ms-13.5 me-2',
      ],attrs:{"color-scheme":_vm.OzDividerColorScheme.Solid,"dark-mode":_vm.darkMode}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }